module.exports = __webpack_public_path__ + "img/vertical_6_7_6000.e67c35bb.png";